import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <div className="border-b border-border bg-card">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/">
            <Button variant="ghost" size="sm" className="gap-2 text-muted-foreground">
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Button>
          </Link>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold mb-2">Terms & Conditions</h1>
        <p className="text-lg text-muted-foreground mb-2">Please read these terms carefully before using our services</p>
        <p className="text-sm text-muted-foreground mb-8">Effective Date: Jan 01, 2025 | Last Updated: Aug 23, 2025</p>

        <div className="space-y-8">
          <section>
            <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
            <p className="text-muted-foreground leading-relaxed">
              These Terms govern the use of HotelAnalytics, a SaaS product by ProwenTech. By accessing or subscribing, you agree to these Terms.
            </p>
          </section>

          <Separator />

          <section>
            <h2 className="text-xl font-semibold mb-3">2. Services</h2>
            <p className="text-muted-foreground leading-relaxed">
              HotelAnalytics provides hotel pricing, competitive intelligence, and analytics dashboards. Features may evolve over time.
            </p>
          </section>

          <Separator />

          <section>
            <h2 className="text-xl font-semibold mb-3">3. Account Registration</h2>
            <ul className="space-y-2 text-muted-foreground list-disc pl-6">
              <li>Users must provide accurate details.</li>
              <li>Accounts are non-transferable.</li>
              <li>You are responsible for maintaining login confidentiality.</li>
            </ul>
          </section>

          <Separator />

          <section>
            <h2 className="text-xl font-semibold mb-3">4. Payments</h2>
            <ul className="space-y-2 text-muted-foreground list-disc pl-6">
              <li>All payments are processed via Razorpay.</li>
              <li>Subscriptions auto-renew unless canceled.</li>
              <li>ProwenTech reserves the right to suspend accounts for failed payments.</li>
            </ul>
          </section>

          <Separator />

          <section>
            <h2 className="text-xl font-semibold mb-3">5. Intellectual Property</h2>
            <p className="text-muted-foreground leading-relaxed">
              All product content, software, and designs belong to ProwenTech. You may not copy, reverse-engineer, or resell without authorization.
            </p>
          </section>

          <Separator />

          <section>
            <h2 className="text-xl font-semibold mb-3">6. User Responsibilities</h2>
            <ul className="space-y-2 text-muted-foreground list-disc pl-6">
              <li>You agree not to misuse the platform.</li>
              <li>Unauthorized scraping, reselling, or security breaches are prohibited.</li>
            </ul>
          </section>

          <Separator />

          <section>
            <h2 className="text-xl font-semibold mb-3">7. Limitation of Liability</h2>
            <p className="text-muted-foreground leading-relaxed">
              We are not liable for indirect damages, service interruptions, or third-party failures (including Razorpay, internet providers).
            </p>
          </section>

          <Separator />

          <section>
            <h2 className="text-xl font-semibold mb-3">8. Termination</h2>
            <p className="text-muted-foreground leading-relaxed">
              We may suspend or terminate accounts that violate these Terms.
            </p>
          </section>

          <Separator />

          <section>
            <h2 className="text-xl font-semibold mb-3">9. Governing Law</h2>
            <p className="text-muted-foreground leading-relaxed">
              These Terms are governed by Indian law.
            </p>
          </section>

          <Separator />

          <section>
            <h2 className="text-xl font-semibold mb-3">10. Contact</h2>
            <p className="text-muted-foreground leading-relaxed mb-3">
              For assistance with accessing your purchased leads or credit-related queries, reach out to:
            </p>
            <div className="p-4 bg-muted/50 rounded-lg text-sm text-muted-foreground space-y-1">
              <p>Email: <a href="mailto:support@prowentech.com" className="text-primary hover:underline">support@prowentech.com</a></p>
              <p>Phone: +91-9087804440</p>
              <p>Website: <a href="https://www.prowentech.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.prowentech.com</a></p>
              <div className="pt-2">
                <p className="font-medium text-foreground">Address:</p>
                <p>Prowen Technologies India Private Limited,</p>
                <p>14/3, LGB Nagar,</p>
                <p>Saravanampatti Post,</p>
                <p>Coimbatore,</p>
                <p>Tamil Nadu 641035</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
